import Service from './abstract';
import usersService from './users';
import platforms from '../constants/users/platforms';
import FLOW_TYPES from '../constants/auth/flowTypes';
import { getCoreLocale } from '../helpers/localeHelper';

const defaultPlatform = platforms.backoffice;

class Login extends Service {
    constructor () {
        super('auth');
    }

    login (email, password, captchaToken) {
        return this.post({
            url: `${this.basePath}/login?with=${usersService.fullWith}`,
            data: {
                idPlatform: defaultPlatform,
                captchaToken,
                payload: { email, password }
            }
        })
            .then(res => usersService.normalize(res));
    }

    // Update the status from blocked to recovery
    recover (id, idPlatform) {
        return this.post({
            url: `${this.basePath}/recover`,
            data: {
                idToken: id, // otp. idUser no va más?
                idUser: id,
                idPlatform: idPlatform
            }
        });
    }

    recoverUser (id) {
        return this.post({
            url: `${this.basePath}/recover/user`,
            data: {
                idToken: id,
                idUser: id
            }
        });
    }

    register (data) {
        const options = {
            url: `${this.basePath}/register`,
            data
        };

        return this.post(options)
            .then(res => {
                return this.post({
                    url: `${this.basePath}/verify`,
                    data: {
                        idPlatform: defaultPlatform,
                        email: data.person.emails[0].email,
                        metadata: {
                            flowType: FLOW_TYPES.ONBOARDING,
                            user: {
                                id: res.id,
                                fullname: data.fullname
                            },
                            url: `${window.location.protocol}//${window.location.host}/auth/otp?flowType=${FLOW_TYPES.ONBOARDING}`,
                            locale: getCoreLocale()
                        }
                    }
                });
            });
    }

    validate (data) {
        return this.post({
            url: `${this.basePath}/validate`,
            data
        });
    }

    validateForgot (data) {
        return this.post({
            url: `${this.basePath}/password/forgot/validate`,
            data
        });
    }

    change (data) {
        return this.post({
            url: `${this.basePath}/password/recover`,
            data
        });
    }

    forgot (data) {
        return this.post({
            url: `${this.basePath}/password/forgot`,
            data
        });
    }

    changeEmail (body) {
        const data = {
            ...body,
            metadata: {
                ...(body?.metadata || {}),
                locale: (body?.metadata && body.metadata.locale) || getCoreLocale()
            }
        };
        return this.post({
            url: `${this.basePath}/verify`,
            data
        });
    }

    validateEmail (body) {
        return this.post({
            url: `${this.basePath}/validate`,
            body
        });
    }

    resendPassword (data) {
        const payload = {
            ...data,
            metadata: {
                ...(data?.metadata || {}),
                locale: (data?.metadata && data.metadata.locale) || getCoreLocale()
            }
        };
        return this.post({
            url: `${this.basePath}/password/resend`,
            data: payload
        });
    }
}

export default new Login();
